import { render } from "./C2c.vue?vue&type=template&id=3510f69d"
import script from "./C2c.vue?vue&type=script&lang=js"
export * from "./C2c.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__